import React, { Fragment } from 'react'
import useCountDown from '@/hooks/useCountdown'
import styles from './index.module.less'

function getShowByNumber(num: number) {
  if (num < 10) {
    return `0${num}`
  }
  return `${num}`
}

function CountDownItem(props: {
  hasBeforeFlags?: boolean
  value: number
  style?: React.CSSProperties
}) {
  const { hasBeforeFlags = true, value, style } = props
  const result = (
    <div style={style} className={styles['count-down-item']}>
      {getShowByNumber(value)}
    </div>
  )
  if (hasBeforeFlags) {
    return (
      <Fragment>
        <div className={styles['flag-wrapper']}>:</div>
        {result}
      </Fragment>
    )
  }
  return result
}

function CountDown(props: {
  seconds: number
  onTimeEnd: () => void
  getDayWord: (d: number) => string
  fromOverdueWord: string
}) {
  const { seconds, onTimeEnd, getDayWord, fromOverdueWord } = props
  const { h, m, s, d } = useCountDown({
    seconds,
    onTimeEnd,
  })
  const dayStr = getDayWord(d)
  return (
    <div className={styles['count-down']}>
      {!!d && (
        <Fragment>
          {fromOverdueWord}
          <CountDownItem
            style={{ margin: '0 0.03rem 0 0.04rem' }}
            value={d}
            key="1"
            hasBeforeFlags={false}
          />
          {dayStr}
        </Fragment>
      )}
      <CountDownItem style={{ marginLeft: '0.02rem' }} value={h} key="1" hasBeforeFlags={false} />
      <CountDownItem value={m} key="2" />
      <CountDownItem value={s} key="3" />
    </div>
  )
}

export default CountDown
